var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextheightsmall = function SvgTextheightsmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 7.2h1.5v9.6H3.2V7.2zm6.7 7.7v-.4c-.3.3-.8.5-1.4.5-.7 0-1.5-.4-1.5-1.4 0-.9.8-1.4 1.5-1.4.6 0 1.1.2 1.4.5V12c0-.5-.4-.8-1-.8-.4 0-.9.1-1.3.5l-.4-.7c.5-.4 1.1-.7 1.8-.7.9 0 1.8.4 1.8 1.5v2.8l-.9.3zm0-1v-.7c-.2-.3-.6-.4-1-.4-.5 0-.9.3-.9.7 0 .4.4.7.9.7.5.2.8 0 1-.3zm2.2 1V9h1v2.2c.4-.4.8-.7 1.4-.7 1.1 0 1.9.9 1.9 2.2 0 1.4-.8 2.2-1.9 2.2-.6 0-1-.3-1.4-.7v.6h-1zm2-.8c.7 0 1.2-.6 1.2-1.4 0-.8-.4-1.4-1.2-1.4-.4 0-.9.3-1.1.6v1.7c.3.3.7.5 1.1.5zm2.8-1.4c0-1.3.9-2.2 2.2-2.2.8 0 1.3.4 1.6.7l-.6.6c-.2-.4-.6-.5-.9-.5-.8 0-1.3.6-1.3 1.4s.5 1.4 1.3 1.4c.4 0 .7-.2.9-.5l.6.6c-.3.4-.8.7-1.6.7-1.2.1-2.2-.8-2.2-2.2z"
  })));
};
export { SvgTextheightsmall as ReactComponent };